import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import WarningIcon from "@material-ui/icons/Warning";
import { makeStyles } from "@material-ui/core/styles";
import { getStandardButtonStyles } from "../../styles/standardButtons";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
	...getStandardButtonStyles(theme),
	dialogPaper: {
		backgroundColor: theme.palette.type === "dark" ? "#1E2126" : "#FFFFFF",
		borderRadius: 16,
		border: `1px solid ${theme.palette.primary.main}`,
		boxShadow: theme.palette.type === "dark" 
			? `0 0 16px ${theme.palette.primary.main}80` 
			: `0 0 12px ${theme.palette.primary.main}40`,
		color: theme.palette.type === "dark" ? "#E2E8F0" : theme.palette.text.primary,
		maxWidth: 480,
		width: "100%",
	},
	dialogHeader: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: theme.spacing(2, 2.5),
		borderBottom: `1px solid ${
			theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)"
		}`,
		"& h2": {
			display: "flex",
			alignItems: "center",
			fontSize: "1.05rem",
			fontWeight: 600,
			margin: 0,
			color: theme.palette.type === "dark" ? "#FFFFFF" : theme.palette.text.primary,
		},
	},
	contentArea: {
		padding: theme.spacing(2.5, 3),
		color: theme.palette.type === "dark" ? "#CBD5E1" : theme.palette.text.secondary,
		lineHeight: 1.6,
	},
	dialogActions: {
		padding: theme.spacing(2, 2.5),
		borderTop: `1px solid ${
			theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)"
		}`,
		display: "flex",
		justifyContent: "flex-end",
		gap: theme.spacing(1),
	},
}));

const ConfirmationModal = ({ title, children, open, onClose, onConfirm }) => {
	const classes = useStyles();

	const handleConfirm = () => {
		onClose(false);
		onConfirm();
	};

	const handleCancel = () => {
		onClose(false);
	};

	const isDangerAction =
		typeof title === "string" &&
		(title.toLowerCase().includes("eliminar") ||
			title.toLowerCase().includes("bloquear") ||
			title.toLowerCase().includes("delete") ||
			title.toLowerCase().includes("block"));

	return (
		<Dialog
			open={open}
			onClose={(event, reason) => {
				if (reason === "backdropClick" || reason === "escapeKeyDown") {
					handleCancel();
				}
			}}
			aria-labelledby="confirm-dialog"
			maxWidth="xs"
			fullWidth
			scroll="paper"
			PaperProps={{
				className: classes.dialogPaper,
			}}
		>
			<div className={classes.dialogHeader}>
				<h2>
					{isDangerAction ? (
						<WarningIcon style={{ marginRight: 8, fontSize: 22, color: "#ff5252" }} />
					) : (
						<HelpOutlineIcon style={{ marginRight: 8, fontSize: 22, color: "#00b4d8" }} />
					)}
					{title}
				</h2>
				<Box display="flex" alignItems="center">
					<Typography
						variant="caption"
						style={{ opacity: 0.6, marginRight: 8, fontWeight: 500 }}
					>
						BotMix | Confirmación
					</Typography>
					<IconButton size="small" onClick={handleCancel} aria-label="Cerrar">
						<CloseIcon fontSize="small" />
					</IconButton>
				</Box>
			</div>

			<DialogContent dividers className={classes.contentArea}>
				<Typography variant="body1">{children}</Typography>
			</DialogContent>

			<DialogActions className={classes.dialogActions}>
				<Button onClick={handleCancel} className={classes.secondaryButton}>
					{i18n.t("confirmationModal.buttons.cancel")}
				</Button>
				<Button
					onClick={handleConfirm}
					className={isDangerAction ? classes.dangerButton : classes.applyButton}
				>
					{i18n.t("confirmationModal.buttons.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
